var map = {
	"./angbao-bonus-thaipusam.webp": 2504,
	"./angbao-bonus.webp": 2505,
	"./angbao-bonus_dewali.webp": 2506,
	"./cny-lucky-draw.webp": 2507,
	"./cny-promo.webp": 2508,
	"./dewali-promo.webp": 2509,
	"./fifa-logo.webp": 2510,
	"./fifa-prediction.webp": 2511,
	"./fifa-qna.webp": 2512,
	"./raya-promo.webp": 2513,
	"./welcome-cny-bonus.webp": 2514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2503;